import $ from 'jquery'
import stringHash from 'string-hash'
const FIELDIDNOTICE = '|notice'
let timeoutList = []
let elCount = 0
let $notice = {
  init: function (msg, title, type, opt) {
    elCount++
    var id = elCount
    timeoutList.push(id)
    var fieldid = stringHash(msg) + FIELDIDNOTICE
    let infoTemplate = `
      <div id="y-notice-${id}" fieldid="${fieldid}" class="y-notice">
        <div class="y-notice-ctn y-notice-info">
          <i class="fa fa-check-circle"></i>${msg}
          <span fieldid="info-${fieldid}" onclick="closenotice()">+</span>
        </div>

      </div>`
    let errorTemplate = `
      <div id="y-notice-${id}" fieldid="${fieldid}" class="y-notice">
        <div class="y-notice-ctn y-notice-error">
          <i class="fa fa-info-circle"></i>${msg}
          <span fieldid="error-${fieldid}" onclick="closenotice()">+</span>
        </div>
      </div>`
    let dialogTemplate = `
      <div id="y-notice-${id}" fieldid="${fieldid}">
        <div class="y-modal-mask"></div>
        <div class="y-modal-wrap" data-bind="css:{animated: visible, fadeInUp: visible}">
          <div class="y-modal" style="width:${opt.width || '600px'}">
            <div class="y-modal-ctn">
              <div class="y-modal-head">
                <span class="y-modal-head-title">${title}</span>
              </div>
              <div class="y-modal-body">
                ${msg}
              </div>
              <div class="y-modal-foot">
                <button class="y-button y-button-primary" id="ok-${id}">${opt.okValue || '确定'}</button>
                <button class="y-button y-button-secondary" id="cancel-${id}">${opt.cancelValue || '取消'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>`
    if (type === 'info') {
      $('body').append(infoTemplate)
    } else if (type === 'error') {
      $('body').append(errorTemplate)
    } else if (type === 'dialog') {
      $('body').append(dialogTemplate)
    }
    setTimeout(() => {
      $('#y-notice-' + id).addClass('y-notice-active')
      if (type === 'dialog') {
        $(`#ok-${id}`).click(() => {
          opt.ok()
          this.close()
        })
        $(`#cancel-${id}`).click(() => {
          opt.cancel()
          this.close()
        })
      }
    }, 100)
  },
  info: function (msg, option = {}) {
    this.init(msg, '', 'info', option)
    setTimeout(() => {
      this.close()
    }, option.timeout || 3000)
  },
  error: function (msg, option = {}) {
    this.init(msg, '', 'error', option)
    setTimeout(() => {
      this.close()
    }, option.timeout || 20000)
  },
  dialog: function (option = {}) {
    this.init(option.content, option.title, 'dialog', option)
  },
  close: function () {
    let curCount = timeoutList.shift()
    let id = '#y-notice-' + curCount
    $(id).removeClass('y-notice-active')
    $(id).addClass('y-notice-hide')
    $(id).remove()
  }
}
window.closenotice = $notice.close
export let notice = $notice



// WEBPACK FOOTER //
// ./src/components/notice/index.js